import {
  createSlice,
} from "@reduxjs/toolkit";
import { Reducer } from "./Reducer";
import { ExportStatus, InitialState } from "./Types";

const initialState: InitialState = {
  isToShowDialog: false,
  versionList: [],
  exportStatus: {} as ExportStatus
};

export const Slice = createSlice({
  initialState,
  name: "versioning",
  reducers: Reducer,
});
